
import {Info} from "react-feather";

export default {
    items: [
        {
            path : '/sms/:id',
            icon : <Info/>,
            label: 'Info',
            slug : 'edit'
        },
    ]
}